import React from "react";
import { motion } from "framer-motion";

const steps = [
  {
    n: "01",
    title: "Call it",
    desc: "Say it out loud, the way you'd call a pet. No app. No taps.",
  },
  {
    n: "02",
    title: "Listen for it",
    desc: "A warm sound pulse answers from wherever it's hiding.",
  },
  {
    n: "03",
    title: "Go get it",
    desc: "Follow the response. Pick it up. Get back to your day.",
  },
];

const HowItWorks = () => {
  return (
    <section
      id="how"
      data-testid="how-section"
      className="relative py-28 md:py-36 bg-[#0A0A0A] text-white overflow-hidden"
    >
      <div className="absolute inset-0 opacity-30 pointer-events-none">
        <div className="absolute top-0 left-0 w-[600px] h-[600px] bg-blue-600/20 blur-3xl rounded-full" />
        <div className="absolute bottom-0 right-0 w-[500px] h-[500px] bg-indigo-500/10 blur-3xl rounded-full" />
      </div>
      <div className="absolute inset-0 opacity-[0.05] [background-image:linear-gradient(to_right,#fff_1px,transparent_1px),linear-gradient(to_bottom,#fff_1px,transparent_1px)] [background-size:64px_64px] pointer-events-none" />

      <div className="relative mx-auto max-w-7xl px-6">
        <div className="flex items-end justify-between flex-wrap gap-6">
          <div className="max-w-2xl">
            <p className="text-xs tracking-[0.2em] uppercase text-blue-300/80 font-medium">A Conversation, Not A Search</p>
            <h2 className="mt-3 font-display text-4xl md:text-5xl font-semibold tracking-tight leading-[1.05]">
              Three words. <span className="italic font-light text-zinc-400">One reply.</span>
            </h2>
          </div>
          <p className="text-zinc-400 max-w-sm text-sm leading-relaxed">
            Designed to feel more like asking a friend than operating a device.
          </p>
        </div>

        <div className="mt-16 grid md:grid-cols-3 gap-5">
          {steps.map((s, i) => (
            <motion.div
              key={s.n}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.6, delay: i * 0.12 }}
              data-testid={`how-step-${i}`}
              className="relative rounded-3xl glass-dark p-8 overflow-hidden"
            >
              <div className="flex items-start justify-between">
                <span className="font-display text-5xl font-light tracking-tight text-white/90">{s.n}</span>
                <span className="text-[10px] tracking-widest uppercase text-zinc-500">Step</span>
              </div>
              <h3 className="mt-10 font-display text-2xl font-semibold tracking-tight">{s.title}</h3>
              <p className="mt-3 text-zinc-400 text-sm leading-relaxed">{s.desc}</p>

              {/* animated sound bar */}
              <div className="mt-8 flex items-end gap-1 h-6">
                {[0, 1, 2, 3, 4, 5, 6, 7].map((b) => (
                  <motion.span
                    key={b}
                    className="w-1 rounded-full bg-gradient-to-t from-blue-400/80 to-white/80"
                    animate={{ height: [6, 18, 6] }}
                    transition={{ duration: 1 + (b % 3) * 0.15, repeat: Infinity, ease: "easeInOut", delay: b * 0.1 + i * 0.3 }}
                  />
                ))}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
